import React, { Component } from 'react';
import { observer } from 'mobx-react';
import Header from './Header';
import Percent from './Percent';
import TableView from './TableView';
import './index.styl';
import realnameStore from './request/model';
import { getRealname, getPersons } from './request/dao';

const clzpre = 'ssfe-realname';

@observer
class Realname extends Component {
    constructor(props) {
        super(props);
        getPersons();
        getRealname();
        this.state = {
            value: ''
        };
        this.intervalData = undefined;
    }

    componentDidMount() {
        this.intervalData = setInterval(getRealname, 1000 * 20);
    }

    componentWillUnmount() {
        clearInterval(this.intervalData);
    }

    render() {
        const { realnames, userStatus } = this.props.realnameStore;

        return (
            <div className={`${clzpre} com-bg`}>
                <section>
                    <Header onSearch={value => this.setState({ value })} />
                    <Percent data={userStatus} />
                    <TableView data={realnames} value={this.state.value} />
                </section>
            </div>
        );
    }
}

export default props => <Realname {...props} realnameStore={realnameStore} />;
